__turbopack_context__.v({
  "accessHeader": "styles-module-scss-module__9pnrGa__accessHeader",
  "accessTitle": "styles-module-scss-module__9pnrGa__accessTitle",
  "bear": "styles-module-scss-module__9pnrGa__bear",
  "bull": "styles-module-scss-module__9pnrGa__bull",
  "card": "styles-module-scss-module__9pnrGa__card",
  "cardHeader": "styles-module-scss-module__9pnrGa__cardHeader",
  "descriptionCard": "styles-module-scss-module__9pnrGa__descriptionCard",
  "descriptionTooltip": "styles-module-scss-module__9pnrGa__descriptionTooltip",
  "divider": "styles-module-scss-module__9pnrGa__divider",
  "fullDisplayWrapper": "styles-module-scss-module__9pnrGa__fullDisplayWrapper",
  "getAccessWrapper": "styles-module-scss-module__9pnrGa__getAccessWrapper",
  "iconWrapper": "styles-module-scss-module__9pnrGa__iconWrapper",
  "icons": "styles-module-scss-module__9pnrGa__icons",
  "mainContent": "styles-module-scss-module__9pnrGa__mainContent",
  "mobileContent": "styles-module-scss-module__9pnrGa__mobileContent",
  "preview": "styles-module-scss-module__9pnrGa__preview",
  "rowWrapper": "styles-module-scss-module__9pnrGa__rowWrapper",
  "title": "styles-module-scss-module__9pnrGa__title",
});
